import React, { useState } from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'

interface Props {
  title: string
  children: React.ReactNode
}

export default function CollapsibleSidebarElement({ title, children }: Props) {
  const [isShown, setIsShown] = useState(true)

  return (
    <div className={'card bg-base-100 shadow-sm mb-2'}>
      <div className="items-center justify-center card-title">
        <button onClick={() => setIsShown(!isShown)} className="btn w-full btn-ghost inline-flex items-center justify-between">
          <span>{title}</span>
          {isShown ? <ChevronUpIcon className="w-4 h-4 ml-2" /> : <ChevronDownIcon className="w-4 h-4 ml-2" />}
        </button>
      </div>
      <div className={'px-4 py-1 card-body'}>{isShown && <>{children}</>}</div>
    </div>
  )
}
